//
// Module for the Batch Adjustment wizard Recipients step
//
rs.module("jobs/criteria/batchadjustment/recipientsstep",

    ["common/visibility"],

    function (visibility) {

        // Initialize the module
        function initialize(jsSelectors) {

            var stepContainer = $.js(jsSelectors.stepContainer);
            var benefitEffectiveFromDate = stepContainer.js(jsSelectors.benefitEffectiveFromDate);
            var benefitEffectiveToDate = stepContainer.js(jsSelectors.benefitEffectiveToDate);
            var useBeneficiaryContainer = stepContainer.js(jsSelectors.useBeneficiaryContainer);
            var useBeneficiaryCheckBox = stepContainer.js(jsSelectors.useBeneficiaryCheckBox);
            var serviceCreditFromInput = stepContainer.js(jsSelectors.serviceCreditFromInput);
            var serviceCreditToInput = stepContainer.js(jsSelectors.serviceCreditToInput);
            var serviceCreditOptionContainer = stepContainer.js(jsSelectors.serviceCreditOptionContainer);
            var serviceCreditOptionTotalRadio = stepContainer.js(jsSelectors.serviceCreditOptionTotalRadio);
            var serviceCreditOptionPerPlanRadio = stepContainer.js(jsSelectors.serviceCreditOptionPerPlanRadio);

            // Hookup benefitEffectiveFromDate and benefitEffectiveToDate change events
            benefitEffectiveFromDate.change(benefitEffectiveDateRangeChange);
            benefitEffectiveToDate.change(benefitEffectiveDateRangeChange);

            // Hookup serviceCreditFromInput and serviceCreditToInput change events
            serviceCreditFromInput.change(serviceCreditRangeChange);
            serviceCreditToInput.change(serviceCreditRangeChange);

            // On Benefit Effective date range change
            function benefitEffectiveDateRangeChange() {

                if (!benefitEffectiveFromDate.val() && !benefitEffectiveToDate.val()) {

                    // Hide and uncheck the Use Beneficiary checkbox
                    visibility.setVisible(useBeneficiaryContainer, false);
                    useBeneficiaryCheckBox.setChecked(false);
                }
                else {
                    // Show the Use Beneficiary checkbox
                    visibility.setVisible(useBeneficiaryContainer, true);
                }
            }

            // On Service Credit range change
            function serviceCreditRangeChange() {

                if (!serviceCreditFromInput.val() && !serviceCreditToInput.val()) {

                    // Hide and reset the Service Credit Options radio buttons
                    visibility.setVisible(serviceCreditOptionContainer, false);
                    serviceCreditOptionTotalRadio.setChecked();
                    serviceCreditOptionPerPlanRadio.setChecked(false);
                }
                else {
                    // Show the Service Credit Options radio buttons
                    visibility.setVisible(serviceCreditOptionContainer, true);
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);